<mat-radio-group [formControl]="radioForm.get('radio')">
    <div class="nivel-logro-group">
    <ng-container *ngFor="let criterioNivel of nivel.criterios">
        <mat-radio-button hidden #radio [value]="criterioNivel.id">
        </mat-radio-button>
        <app-boton-criterio [criterioNombre]="criterioNivel.nombre"
            [criterioId]="criterioNivel.id"
            [autoevaluacion]="alumno.criteriosAutoevaluacion"
            [urlImagen]="alumno.imageUrl"
            [radio]="radio"
            [radioForm]="radioForm"
            [label]="criterioNivel.escala.nickName"
            [mostrarAutoevaluacion]="mostrarAutoevaluacion$ | async"></app-boton-criterio>
    </ng-container>
    </div>
</mat-radio-group>
